<template>
  <div class="page_wrapper">
    <div class="cstm_container">
      <section class="chatscreen wdth100">
        <div class="chat_header wdth100">
          <a href="javascript:void(0);" class="back_icn" @click="goBack()">
            <i class="material-icons" style="line-height: 1.5; color: #fff;">keyboard_backspace</i>
          </a>
          <a href="javascript:void(0);" class="profile_icn">
            <img src="../assets/images/money91.png" class="mall91" />
          </a>
          <h5>
            मॉल91 शॉपिंग सर्विस
            <transition name="fade">
              <span>online</span>
            </transition>
          </h5>
        </div>
        <div class="chat_body_wrap wdth100" v-bind:class="{'mobile-website':iswebsite}">
          <div class="chat_body wdth100">
            <div class="wdth100" v-for="msg in chats">
              <div
                v-bind:class="{'incoming_msg':msg.incoming, 'outgoing_msg':!msg.incoming, 'max-width-100p':msg.data.v}"
              >
                <video v-if="msg.data.v" width="100%" controls>
                  <source v-bind:src="msg.data.v" type="video/mp4" />Your browser does not support the video tag.
                </video>
                <img v-if="msg.data.i" v-bind:src="msg.data.i" width="100%" alt="msg" />
                <a class="break-all" v-if="msg.data.a" :href="msg.data.a">यहाँ क्लिक करे</a>
                <p
                  v-if="msg.data.t"
                  v-html="msg.data.t.replace(/\n/g, '<br />').replace(/\*(.?)\*/g , '<strong>$1</strong>')"
                ></p>
                <span class="chat_tym">
                  {{new Date(msg.timestamp*1000).toLocaleTimeString()}}
                  <img
                    v-if="!msg.incoming"
                    src="../assets/images/double.tick.svg"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="write_msg wdth100">
            <div class="chat_wrap wdth100">
              <input
                type="text"
                @keyup="checkKey($event)"
                class="chat_input"
                @focus="scrollToBottom"
                v-model="msg"
                placeholder="type a message"
              />
            </div>
            <a @click="sendMessage()" class="voice_icn">
              <img src="../assets/images/speak_icn.png.svg" alt="sendmessage" />
            </a>
          </div>
        </div>
      </section>
    </div>
    <div v-bind:class="{'hide':!loading}" class="loader-parent">
      <div class="loader-img">
        <img src="../assets/images/loading.gif" alt="loader" />
      </div>
    </div>
  </div>
</template>
<script>
import constant from "../utils/constant";
import { bus } from "../main";
export default {
  name: "Chat",
  data() {
    return {
      page: 0,
      listener: null,
      msg: null,
      msgs: [],
      db: null,
      chats: [],
      loading: false,
      iswebsite: false
    };
  },
  mounted() {
    var _this = this;
    this.startConversation();
    this.iswebsite = this.$cookie.get("app-name") == null ? true : false;
  },
  methods: {
    checkKey: function(e) {
      if (e.keyCode == 13 && !e.shiftKey) {
        this.sendMessage();
      }
    },
    firebaseConnection() {
      var _this = this;
      _this.database
        .ref(this.$cookie.get("contact") + "/messages")
        .limitToLast(10)
        .on("child_added", function(data) {
          var doc = data.val();
          for (var i in doc.msg) {
            var obj = {
              data: doc.msg[i],
              timestamp: doc.timestamp,
              incoming: doc.from == "bot" ? true : false
            };
            _this.chats.push(obj);
          }
          setTimeout(function() {
            _this.scrollToBottom();
          }, 200);
        });
    },
    connectToFirebase() {
      var _this = this;
      _this.firebaseConnection();
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    scrollToBottom() {
      let height =
        document.getElementsByClassName("chat_body")[0].scrollHeight + 10;
      document.getElementsByClassName("chat_body")[0].scrollTo(0, height);
    },
    goBack: function() {
      this.$router.back();
    },
    sendMessage: function() {
      if (this.msg.trim().length > 0) {
        this.talkToAI(
          this.$cookie.get("contact") != null
            ? this.$cookie.get("contact")
            : null,
          this.msg
        );
        var _ = {
          incoming: false,
          time: new Date().toLocaleTimeString(),
          msg: this.msg
        };
        this.insertIntoLocalDB(_);
        this.msgs.push(_);
        this.msg = "";
        this.scrollToBottom();
      }
    },
    talkToAI: function(mobileno, msg) {
      var _this = this;
      var obj = {
        preorderid: this.$route.params.preOrderId,
        mobileno: mobileno != null ? mobileno : null,
        msg: msg != null ? msg : null
      };
      this.loading = true;
      this.$store
        .dispatch({
          type: "startChat",
          payload: obj
        })
        .then(function(data) {
          this.scrollToBottom();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.error = true;
          this.emitToaster("Failure");
        });
    },
    startConversation: function() {
      var _this = this;
      if (this.$cookie.get("X-Auth-Id") == null) {
        var uid = this.uuidv4();
        this.$cookie.set("contact", uid);
        this.connectToFirebase();
        _this.talkToAI(null, null);
      } else {
        var xid = this.$cookie.get("X-Auth-Id");
        this.$store
          .dispatch({
            type: "getChatUser",
            payload: xid
          })
          .then(data => {
            _this.$cookie.set("contact", data.data.phone);
            this.connectToFirebase();
            _this.talkToAI(data.data.phone, null);
          })
          .catch(err => {
            _this.talkToAI(null, null);
            this.emitToaster("Failure");
          });
      }
    },
    getProductDetails(isAlreadySignup) {
      this.loading = true;
      var obj = {
        saleReferenceID: this.$route.params.productId,
        referralUserId: this.$route.params.encodedId,
        applicationName: "ResellerBoard",
        isAlreadySignup: isAlreadySignup
      };
      var _this = this;
      this.$http
        .post(constants.BASE_URL + "sales-details", obj, {
          headers: {
            lang: this.$cookie.get("lang")
          }
        })
        .then(function(data) {
          this.loading = false;
          this.details = data.body;
          setTimeout(function() {
            var _ = {
              incoming: true,
              time: new Date().toLocaleTimeString(),
              msg: "आप खरीद रहे है - " + data.body.productName
            };
            _this.msgs.push(_);
            _this.insertIntoLocalDB(_);
          }, 100);
        })
        .catch(err => {
          this.loading = false;
          this.error = true;
          this.emitToaster("Failure");
        });
    },
    insertIntoLocalDB(object) {},
    emitToaster(status) {
      let obj = {
        status: status,
        timeoutMs: "5000"
      };
      bus.$emit("apiStatus", obj);
    }
  }
};
</script>
<style scoped>
.max-width-100p {
  max-width: 98% !important;
}
.chatscreen {
  position: fixed;
  z-index: 999999999;
  left: 0;
}
.page_wrapper {
  width: 100%;
  float: left;
  height: 100%;
}
section {
  width: 100%;
  float: left;
}

ul {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
}

a,
a:hover,
a:focus {
  text-decoration: none;
}

.container.cstm_container {
  max-width: 767px;
  width: 100%;
  padding: 0px;
}

.wdth100 {
  width: 100%;
  float: left;
}

.d_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile_icn > i {
  color: #fff;
}

.profile_icn img {
  margin-left: 4px;
  width: 40px;
}

.chat_header {
  background: #075e4b;
  padding: 10px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  position: relative;
  box-shadow: 0px 2px 10px #c9ccc2;
}
.chat_header i {
  line-height: 1.5;
  color: #fff;
}
.chat_headerimg {
  max-width: 100%;
}

.back_icn img {
  width: 24px;
  padding-top: 8px;
  line-height: normal;
}

.chat_header h5 {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  margin-left: 8px;
}

.chat_header h5 > span {
  display: block;
  font-size: 12px;
  color: rgba(250, 250, 250, 0.8);
  padding-top: 3px;
}

.list_icn {
  position: absolute;
  right: 0;
}

.chat_body_wrap {
  background: url(../assets/images/wo.png);
  background-size: cover;
  height: calc(100vh - 56px);
  position: relative;
  overflow: hidden;
  margin-top: 3px;
}

.chat_body {
  padding: 10px;
  height: auto;
  overflow-y: auto;
  position: absolute;
  bottom: 53px;
  left: 0;
  right: 0;
  max-height: calc(100vh - 100px);
}

.chat_body p {
  font-size: 14px;
  line-height: normal;
  font-weight: 500;
  padding-bottom: 10px;
}

.incoming_msg {
  float: left;
  margin-left: 12px;
  border-top-left-radius: 0px !important;
}

.incoming_msg,
.outgoing_msg {
  background: #fff;
  min-height: 30px;
  border-radius: 4px;
  padding: 6px 12px;
  position: relative;
  box-shadow: 3px 2px 10px #ada8a8;
  margin-bottom: 12px;
  max-width: 250px;
  width: 100%;
}

.incoming_msg:before {
  content: "";
  position: absolute;
  top: -6px;
  left: -10px;
  background: url("../assets/images/icons/arrow_down.svg") no-repeat;
  background-size: 100%;
  width: 20px;
  height: 20px;
}

.chat_tym {
  position: absolute;
  right: 5px;
  bottom: 1px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.6);
}
.chat_tym img {
  width: 14px;
  margin-bottom: 1px;
}

.outgoing_msg {
  background: #e3ffc8;
  float: right;
  margin-right: 12px;
}

.outgoing_msg:after {
  content: "";
  position: absolute;
  top: -6px;
  right: -10px;
  background: url("../assets/images/icons/arrow_green.svg") no-repeat;
  background-size: 100%;
  width: 20px;
  height: 20px;
}

.write_msg {
  position: absolute;
  bottom: 0px;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  padding-bottom: 10px;
}

.chat_wrap {
  position: relative;
  /*max-width: 238px;*/
  padding-right: 10px;
  width: 100%;
}

.chat_input {
  border: none;
  border-radius: 30px;
  padding: 11px 38px 11px 20px;
  width: 100%;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  text-transform: capitalize;
  font-weight: 500;
}

.camera_icn {
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -16px;
}

.camera_icn > img {
  width: 26px;
}

.voice_icn {
  display: inline-block;
}
.voice_icn img {
  width: 44px;
}

.chat_input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(0, 0, 0, 0.54);
  text-transform: capitalize;
  font-weight: 500;
}
.chat_input::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(0, 0, 0, 0.54);
  text-transform: capitalize;
  font-weight: 500;
}
.chat_input:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(0, 0, 0, 0.54);
  text-transform: capitalize;
  font-weight: 500;
}
.chat_input:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(0, 0, 0, 0.54);
  text-transform: capitalize;
  font-weight: 500;
}
.chat_input:focus {
  outline: none;
}
.loader-parent {
  position: fixed;
  top: 0px;
  left: -20px;
  width: 100vw;
  height: 100vh;
  z-index: 99999999999;
  background: rgba(0, 0, 0, 0.2784313725490196);
}
.loader-img {
  position: absolute;
  left: calc(50% - 64px);
  top: calc(50% - 64px);
  z-index: 99999999999;
}
.loader-img img {
  width: 128px;
}
.break-all {
  word-break: break-all;
}
.mobile-website .chat_body {
  bottom: 100px !important;
}
.mobile-website .write_msg {
  bottom: 10px !important;
}
</style>
